import { combineReducers } from "redux"

// Front
import Layout from "./layout/reducer";

// Calendar
import Calendar from "./calendar/reducer";

// Ecommerce
import Ecommerce from "./ecommerce/reducer";

// Authentication
import login from "./auth/login/reducer";
import profile from "./auth/profile/reducer";
import account from "./auth/register/reducer";

// Reporting
import Reporting from "./reporting/reducer";

// Reporting → Inventory aggregate (Asset Health + future Inventory tab)
import ReportingInventory from "./reportingInventory/reducer";

// Escalation
import Escalation from "./escalation/reducer";

// Meter
import Meter from "./meter/reducer";

// Materiovigilance (Compliance)
import Materiovigilance from "./materiovigilance/reducer";

// Active context (Global Organizations)
import ActiveContext from "./activeContext/reducer";

// Teams
import Team from "./team/reducer";

// Time entries (work-order labor time logging)
import TimeEntry from "./timeEntry/reducer";

// Work-order cost (contractor cost + aggregate)
import WorkOrderCost from "./workOrderCost/reducer";

// Asset cost rollup (cumulative maintenance cost on an asset)
import AssetCost from "./assetCost/reducer";

// Asset TCO (composed total cost of ownership)
import AssetTCO from "./assetTCO/reducer";

const rootReducer = combineReducers({
  // public
  Layout,
  Calendar,
  login,
  profile,
  account,
  Ecommerce,
  Reporting,
  ReportingInventory,
  Escalation,
  Meter,
  Materiovigilance,
  ActiveContext,
  Team,
  TimeEntry,
  WorkOrderCost,
  AssetCost,
  AssetTCO,
})

export default rootReducer;
